import { api } from '@/lib/api'

type BulkPaymentResponse = {
  id: string
}

export function createBulkPayment() {
  return api.post<BulkPaymentResponse>(`/v1/me/bulk-payments`)
}
